import { useCallback, useMemo } from 'react';
import DayPicker from 'react-day-picker';
import moment from 'moment';
import { Colors } from '../../../themes/colors';

export const CalendarSelection = ({ maxDaysToSelect, selectedDates = [], onChange }) => {
  const modifiersStyles = useMemo(
    () =>
      Object.keys(selectedDates)
        .map((key) => ({
          [key]: {
            backgroundColor: Colors.secondary_500,
            color: Colors.white,
          },
        }))
        .reduce((a, b) => ({ ...a, ...b }), {}),
    [selectedDates],
  );

  const handleDayClick = useCallback(
    (day, { disabled }) => {
      if (disabled) return;

      const date = moment(day).format('YYYY-MM-DD');

      if (Object.keys(selectedDates).includes(date)) {
        const { [date]: val, ...childWithout } = selectedDates;
        onChange(childWithout);
      } else {
        onChange({ ...selectedDates, [date]: day });
      }
    },
    [selectedDates, onChange],
  );

  return (
    <DayPicker
      modifiers={selectedDates}
      modifiersStyles={modifiersStyles}
      onDayClick={handleDayClick}
      selectedDays={selectedDates}
      fromMonth={new Date()}
      disabledDays={{
        before: new Date(),
        after: maxDaysToSelect ? moment().add(maxDaysToSelect, 'days').toDate() : undefined,
      }}
    />
  );
};
